<template>
  <v-sheet class="hero-banner rounded-xl mb-6 pa-6 pa-md-8" dark elevation="4">
    <v-row align="center" no-gutters>
      <v-col cols="12" md="8" class="d-flex align-center">
        <v-avatar size="64" color="white" class="mr-4 elevation-3">
          <v-img v-if="school && school.logo" :src="school.logo"></v-img>
          <v-icon v-else size="34" color="primary">mdi-school</v-icon>
        </v-avatar>
        <div>
          <div class="text-h5 font-weight-bold">{{ greeting }}, {{ schoolName }}!</div>
          <div class="hero-subtitle">
            {{ school && school.motto ? school.motto : "Here's what's happening with your school today." }}
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4" class="text-md-right mt-4 mt-md-0">
        <v-chip class="ma-1" color="white" outlined label>
          <v-icon left small>mdi-calendar-month</v-icon>{{ currentSession || '—' }}
        </v-chip>
        <v-chip class="ma-1" color="white" outlined label>
          <v-icon left small>mdi-pound-box</v-icon>{{ currentTerm || '—' }}
        </v-chip>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
    name: 'Header',
    data: () => ({
        school: localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        currentSession: localStorage.getItem('currentSession') || null,
        currentTerm: localStorage.getItem('currentTerm') || null,
    }),
    computed: {
        schoolName() {
            return this.school ? this.school.name : 'there';
        },
        greeting() {
            const hour = new Date().getHours();
            if (hour < 12) return 'Good morning';
            if (hour < 17) return 'Good afternoon';
            return 'Good evening';
        },
    },
}
</script>

<style scoped>
.hero-banner {
  background: linear-gradient(135deg, #00695c 0%, #1e3c72 100%);
}
.hero-subtitle {
  opacity: 0.85;
  font-size: 0.95rem;
  margin-top: 2px;
}
</style>
